const messages = {
    pt: {
        translations: {
            code: "Código",
            description: "Descrição",
            search: "Buscar",
            active: "Ativo",
            created_at: "Criado em",
            modified_at: "Modificado em",
            actions: "Ações",
            cancel: "Cancelar",
            save: "Salvar",
            sector: "Setor",
            production_line: "Linha de produção",
            automatic_phase: "Fase automática",
            phase: "Fase",
            new_machine: "Nova Máquina",
            machine: "Máquina",
            process: "Processo",
            proceed: "Prosseguir",
            new: "Novo",
            cost_center: "Centro de custo",
            tag_code: "Código da etiqueta",
            criticality: "Criticidade",
            efficiency: "Eficiência",
            last_maintenance_date: "Data da última manutenção",
            frequency: "Periodicidade",
            utilization_index: "Índice de aproveitamento",
            used_calendar: "Calendário utilizado",
            conference_property: "Propriedade de conferência",
            security_interval: "Intervalo de seguranca",
            unlimited_resource: "Recurso ilimitado",
            area: "Área",
            sequence: "Sequência",
            centesimal_working_hours: "Horas úteis trabalhadas centesimais ",
            saturday_working_hours: "Horas úteis trabalhadas no sábado",
            sunday_working_hours: "Horas úteis trabalhadas no domingo",
            period_working_hours: "Horas úteis do período",
            period_used_hours: "Horas utilizadas no período",
            yield_percentage: "% Rendimento",
            warehouse_consumption: "Armazém de consumo",
            warehouse_description: "Descrição do armazém",
            shift: "Turno",
            initial: "Horário inicial",
            final: "Horário final",
            start: "Início",
            product: "Produto",
            unit_measurement: "Unidade de medida",
            abbreviation: "Sigla",
            rows_per_page: "Itens por página",
            product_details: "Detalhes do produto",
            item_code: "Código do item",
            alternative_code: "Código alternativo",
            specific_description: "Descrição específica",
            portuguese_description: "Descrição em português",
            english_description: "Descrição em inglês",
            nickname: "Apelido",
            username: "Usuário",
            password: "Senha",
            recoverPassword: "Redefinir senha",
            confirmPassword: "Confirmar senha",
            email: "E-mail",
            superuser: "Super Usuário",
            product_type: "Tipo do produto",
            raw_material: "Matéria-prima",
            finished_product: "Produto acabado",
            intermediate_product: "Produto intermediário",
            model: "Modelo",
            part_number: "Part number",
            part_number_client: "Part number do cliente",
            manufacturer: "Fabricante",
            expiration_date: "Prazo de validade",
            gross_weight: "Peso bruto",
            revision: "Revisão",
            last_revision: "Data da última revisão",
            minimum_grade: "Nota mínima",
            division: "Divisão",
            inventory_frequency: "Periodicidade do inventário",
            base_quantity_structure: "Quantidade base da estrutura",
            decimal_places_production_order: "Tipo de decimais para ordem de produção",
            normal_treatment_without_decimals: "Tratamento normal sem decimais",
            round: "Arredonda",
            increments: "Incrementa",
            truncate_decimal_places: "Trunca as casas decimais",
            model_car: "Modelo do veículo que recebe o produto acabado (BIKE/CAR)",
            direct_or_indirect_appropriation: "Apropriação direta ou indireta",
            direct: "Direta",
            indirect: "Indireta",
            optional_default_group: "Grupo de opcional padrão",
            truncate_or_round: "Trunca ou arredonda",
            truncate: "Trunca",
            block: "Bloqueio de tela",
            enter_mrp: "Entra no MRP?",
            attend_need: "Atende a necessidade",
            notes: "Observação",
            unit_of_measurement: "Unidade de medida",
            unit_measurement_internal: "Unidade de medida interna",
            unit_measurement_entry: "Unidade de medida de entrada",
            second_unit_measurement: "Segunda unidade de medida",
            conversion_factor: "Fator de conversão de unidade de medida",
            conversion_type: "Tipo de conversão da unidade de medida",
            multiplies: "Multiplica",
            divide: "Divide",
            cost_purchase: "Custo/Compra",
            default_supplier: "Fornecedor padrão",
            store_default_supplier: "Loja fornecedor padrão",
            minimum_quantity_order: "Ponto de pedido",
            reference_value_uss: "Valor referência US$",
            sale_price: "Preço de venda",
            last_purchase_currency: "Última moeda de compra",
            last_purchase_value: "Último valor de compra",
            last_purchase: "Data da última compra",
            default_cost_currency: "Moeda do custo standard",
            default_cost: "Custo standart",
            last_calculation_default_cost: "Data do último cálculo do custo padrão",
            fob_cost_currency: "Moeda do custo FOB",
            fob_cost: "Custo FOB",
            last_calculation_fob_cost: "Data do último cálculo do custo FOB",
            delivery_time: "Prazo de entrega",
            delivery_time_type: "Tipo do prazo de entrega (D/M/A)",
            hours: "Horas",
            days: "Dias",
            months: "Meses",
            years: "Anos",
            calculation_delivery_time_formula: "Formula cálculo do prazo",
            tolerance: "Tolerância",
            stock: "Estoque",
            stock_group: "Grupo de estoque",
            maximum_stock: "Estoque máximo",
            security_stock: "Estoque de segurança",
            economic_lot: "Lote econômico",
            minimum_lot: "Lote mínimo",
            packing_quantity: "Quantidade por embalagem",
            security_stock_formula: "Fórmula do estoque de segurança",
            default_warehouse: "Armazem padrão por requisição",
            traceability: "Rastreabilidade",
            product_origin: "Origem do produto",
            national: "Nacional",
            foreign_direct_import: "Estrangeira importação direta",
            foreign_adq_domestic_market: "Estrangeira-Adq no mercado interno",
            foreign: "Estrangeira",
            product_traceability: "Rastreabilidade do produto",
            subbatch_traceability: "Rastreabilidade sublote",
            does_not_use_traceability: "Não usa rastreabilidade",
            batch_traceability: "Rastreabilidade lote",
            default_production_map_operation: "Roteiro de operação padrão",
            copy_quantity_bar_code: "Quantidade cópias para código de barras",
            bar_code: "Código de barras",
            imported_product: "Produto importado",
            purchased_out_state: "Comprado fora do estado",
            family: "É família",
            ghost: "É fantasma",
            controls_addressing: "Controla endereçamento",
            own_third_or_party: "Produção própria ou terceiro",
            own: "Própria",
            third: "Terceiro",
            product_base: "Produto base",
            product_component: "Produto componente",
            loss_index: "Índice de perda",
            initial_validity: "Data inicial da validade",
            final_validity: "Data final da validade",
            process_time: "Tempo do processo",
            quantity_type: "Quantidade fixa/variável",
            optional_group: "Grupo de opcionais",
            item_optional_group: "Item do grupo de opcionais",
            initial_revision: "Revisão inicial do componente",
            final_revision: "Revisão final do componente",
            product_level: "Nível do produto",
            reverse_product_level: "Nível invertido",
            lot_potency: "Potência do lote",
            warehouse: "Armazém de consumo",
            quantity: "Quantidade",
            alternative_use: "Usa alternativo?",
            file_imported: "Arquivo importado",
            import_file: "Importar arquivo",
            import: "Importar",
            user: "Usuário",
            name: "Nome",
            legacy_code: "Código legado",
            group: "Grupo",
            menu: "Menu",
            visible: "Visível",
            permission: "Permissão",
            successfully_updated: "Atualizado com sucesso",
            successfully_registered: "Cadastrado com sucesso",
            successfully_deleted: "Excluído com sucesso",
            successfully_uploaded: "Importado com sucesso",
            required_field: "O campo é obrigatório.",
            exceeds_character_limit: "Limite de caracteres excedido.",
            must_be_a_integer_number: "deve ser um número inteiro",
            must_be_a_number: "deve ser um número",
            unique_validation_failure: "falha de validação única",
            must_be_a_positive_number: "deve ser um número positivo",
            cannot_insert_update_duplicate_key: "Não é possível inserir ou atualizar um registro duplicado",
            fixed: "Fixo",
            variable: "Variável",
            invalid_time_format: "Formato de hora inválido",
            invalid_date_format: "Formato de data inválido",
            invalid_number_format: "Formato de número inválido",
            default_moment_locale: "pt-br",
            token_error_redirecting: "Token inválido. Redirecionando...",
            of: "de",
            basic_inputs: "Cadastros básicos",
            product_process: " Produto - Processo",
            invalid_file: "Arquivo inválido",
            enter: "Entrar",
            welcome_home: "Bem-vindo ao",
            invalid_credentials: "Não é possível realizar login com as credenciais fornecidas.",
            logout: "Sair",
            profile: "Perfil",
            session_expired: "Sua sessão expirou.",
            session_information: "Faça login para continuar conectado.",
            login_failed: "Não é possível realizar login, verifique sua conexão.",
            confirm: "Confirmar",
            edit: "Editar",
            delete: "Deletar",
            save_form: "Salvar",
            superUser: "Administrador",
            confirm_delete: "Você tem certeza que deseja excluir esse item?",
            password_not_match: "As senhas não são iguais.",
            confirm_recover_password_tittle: "Confirmar redefinição de senha",
            confirm_recover_password_text: "Você tem certeza de que deseja redefinir a senha deste usuário?",
            product_line: "Linha de produção",
            planning: "Planejamento",
            simulation: "Simulação",
            is_active: "Ativo",
            is_superuser: "Administrador",
            undefined: "Indefinido",
            module: "Módulo",
            modules: "Módulos",
            root_description: "Módulo",
            empty_listing: "Nenhum registro encontrado.",
            no_shift: "Nenhum turno encontrado.",
            new_password: "Nova senha",
            confirm_new_password: "Confirmar nova senha",
            security: "Segurança",
            status: "Status",
            inactive: "Inativo",
            codename: "Código",
            redefine_password: "Redefinir senha",
            grant_permission: "Conceda todas as permissões.",
            deny_permission: "Negue todas as permissões.",
            codename_or_name: "Nome / Código",
            error_user_selected: "Selecione um usuário para adicionar a permissão.",
            history: "Histórico",
            invalid_edit_group: "Já existe um grupo com este nome.",
            invalid_edit_user: "Já existe um usuário com esses dados.",
            general: "Geral",
            type_process: "Tipo de processo",
            hybrid: "Híbrido",
            available_production_line: "Estações disponíveis para linha de produção:",
            used_production_line: "Utilizados na linha de produção:",
            info_ordination: "Arraste os itens para ordená-los.",
            history_update: "Editado",
            history_create: "Adicionado",
            history_delete: "Excluído",
            is_staff: "É pessoal",
            is_default: "É padrão",
            true: "Sim",
            false: "Não",
            modified_to: "modificado para",
            segment: "Segmento",
            station: "Estação",
            unscheduled_stop: "Parada não programada",
            confirm_type_process: "Confirmar edição",
            confirm_type_process_text: "Esta linha de produção possui estação associada, você realmente deseja alterar o tipo de processo? Associações serão perdidas.",
            programmed_shutdown: "Parada programada",
            duration: "Duração",
            type: "Tipo",
            commercial: "Part Number Commercial",
            name_or_commercial: "Part Number Commercial ou Produto",
            start_validity: "Inicio da vigência",
            end_validity: "Fim da vigência",
            search_name: "Buscar nome",
            search_programmed: "Buscar parada programada",
            validity_start_date: "Início da vigência",
            validity_end_date: "Fim da vigência",
            start_time: "Hora de início",
            end_time: "Hora de término",
            error_required_field: "Verifique se todos os campos obrigatórios foram preenchidos.",
            invalid_group: "Já existe um grupo com este nome.",
            replanning_reason: "Motivo de Replanejamento",
            reason: "Motivo",
            cause: "Motivo Padrão",
            yes: "Sim",
            no: "Não",
            the_record_already_exists: "O registro já existe",
            loading: "Carregando",
            invalid_format: "Formato inválido",
            order: "Ordem",
            search_shift: "Buscar turno",
            workday: "Jornada de trabalho",
            length: "Duração",
            error_programmed_selected: "Selecione uma parada programada para associar ao turno.",
            module_options: "O que você deseja fazer?",
            production_capacity: "Capacidade de produção",
            basic: "Básico",
            reports: "Relatórios",
            settings: "Configurações",
            access_control: "Controle de acesso",
            invalid_email: "Você deve inserir um e-mail válido.",
            registrations: "Cadastros",
            demand: "Demanda",
            production_planning: "Planejamento de produção",
            replanning_history: "Histórico de replanejamento",
            smt_default_time: "Tempo padrão de SMT",
            manual_default_time: "Tempo padrão manual",
            scheduled_stop: "Paradas programadas",
            reason_replanning: "Motivo de replanejamento",
            production_ramp: "Rampa de produção",
            calendar_event_type: "Tipo de evento do calendário",
            calendar: "Calendário",
            marker: "Marcador",
            reason_replanning_report: "Motivos de replanejamento",
            production_line_usage: "Utilização de linhas de produção",
            realized_vs_planned: "Realizado vs planejado",
            preferences: "Preferências",
            expression_builder: "Construtor de expressões",
            headcount: "Quantidade de pessoas",
            stops: "Paradas",
            line_configuration: "Configuração de linha",
            default: "Padrão",
            color: "Cor",
            search_description: "Buscar descrição",
            useful_day: "Dia útil",
            day_off: "Dia de folga",
            pn_commercial: "PN Comercial",
            is_top_bottom: "Top-Bottom",
            component: "Componente",
            sides: "Lados",
            add: "Adicionar",
            production_ramp_settings: "Configurações da rampa",
            npi: "NPI",
            module_under_construction: "Módulo em construção",
            module_under_construction_description: "Esta área ainda não tem funcionalidades disponíveis. Em breve novidades por aqui.",
            no_modules_available: "Nenhum módulo disponível para o seu perfil. Solicite acesso ao administrador, se necessário.",
            back_to_home: "Voltar para a página inicial",
            side: "Lado",
            version: "Versão",
            production_order: "Ordem de produção",
            reference_date: "Data de referência",
            font_color: "Cor da fonte",
            production_order_peripheral: "Ordem de produção dos periféricos",
            lines: "Linhas",
            production_ramp_day: "Dia ",
            validate_production_lines: "As linhas de produção devem conter as mesmas configurações",
            duplicate: "Duplicar",
            default_time_seconds: "Tempo padrão",
            people_quantity: "Quantidade de pessoas",
            capacity: "Capacidade",
            default_expression: "Expressão padrão:",
            expression: "Expressão",
            initial_date: "Data inicial",
            final_date: "Data final",
            available: "Disponível",
            planned: "Planejado",
            in_production: "Em produção",
            finished: "Finalizado",
            january: "Janeiro",
            february: "Fevereiro",
            march: "Março",
            april: "Abril",
            may: "Maio",
            june: "Junho",
            july: "Julho",
            august: "Agosto",
            september: "Setembro",
            october: "Outubro",
            november: "Novembro",
            december: "Dezembro",
            message_home: "O NRE Control é um sistema de planejamento de produção.",
            save_plus: "Salvar +",
            close: "Fechar",
            clear: "Limpar",
            open: "Abrir",
            month: "Mês",
            year: "Ano",
            event: "Evento",
            start_date: "Data inicial",
            end_date: "Data final",
            validate_end_time: "Este tempo deve ser maior",
            validate_event_create: "Só é permitido criar um evento após a data atual",
            available_time: "Tempo disponível",
            return_value: "Valor de retorno",
            default_time: "Tempo padrão",
            assemble_expression: "Monte a expressão:",
            set_default_expression: "Definir como expressão padrão",
            AVAILABLE_TIME: "TEMPO DISPONÍVEL",
            DEFAULT_TIME: "TEMPO PADRÃO",
            PEOPLE_QUANTITY: "QUANTIDADE DE PESSOAS",
            CAPACITY: "VOLUME",
            volume: "Volume",
            day: "Dia",
            line: "Linha",
            duplicate_version: "Duplicar versão",
            delete_version: "Deletar versão",
            change_final_version: "Alterar para versão final",
            duplicate_version_successfully: "Versão duplicada com sucesso",
            confirm_make_version_final: "Deseja realmente tornar a versão ($description) como final?",
            to_plan: "Planejar",
            sunday: "Domingo",
            monday: "Segunda-Feira",
            tuesday: "Terça-Feira",
            wednesday: "Quarta-Feira",
            thursday: "Quinta-Feira",
            friday: "Sexta-Feira",
            saturday: "Sábado",
            new_marker: "Novo marcador",
            peripheral: "Periféricos",
            interrupt_demand: "Interromper demanda",
            markers: "Marcadores",
            remove_planning_message: "Deseja remover o planejamento?",
            can_not_edit_planning_with_final_version: "Não é possível fazer alteração em uma versão de produção.Altere uma versão duplicada e depois publique",
            production_line_top: "Linha de produção TOP",
            production_line_bot: "Linha de produção BOTTON",
            demand_total: "Total da demanda",
            shift_to_start: "Turno para inicio",
            line_setup_stop: "Parada de setup de linha",
            different_line: "Fases A e B em linhas diferentes",
            shifts: "Turnos",
            production_line_backend: "Linha de produção backend",
            associate_shift: "Associar turno",
            no_associated_shift: "Nenhum turno associado",
            value_day_one: "Valor do dia 1",
            value_day_two: "Valor do dia 2",
            value_day_three: "Valor do dia 3",
            value_day_four: "Valor do dia 4",
            value_day_five: "Valor do dia 5",
            value_day_six: "Valor do dia 6",
            value_day_seven: "Valor do dia 7",
            production_line_required: "Selecione ao menos uma linha de produção",
            info_demand: "Informação da demanda",
            edit_demand: "Editar demanda",
            history_month: "Histórico no mês",
            balance: "Saldo",
            planned_quantity: "Planejado",
            move_balance: "Mover saldo",
            bone_pile: "Defeito",
            scrap: "Sucata",
            realized: "Realizado",
            finalize_demand: "Finalizar demanda",
            info_finalize_demand: "Deseja finalizar a demanda?",
            finalize: "Finalizar",
            smt_configuration: "Sem configuração de tempo SMT",
            manual_configuration: "Sem configuração de tempo Manual",
            unknown_error: "Oops... ocorreu algo inesperado!",
            service_unavailable: "O sistema está temporariamente indisponível devido a uma atualização ou manutenção. Tente novamente em alguns minutos.",
            new_simulation: "Nova simulação",
            new_version: "Nova versão",
            all_rights_reserved: "Todos os direitos reservados.",
            developed_by: "Desenvolvido por",
            edit_planning: "Editar planejamento",
            smt_warnning: "Tempo SMT",
            manual_warnning: "Tempo Manual",
            valid_quantity: "Quantidade não pode ultrapassar o valor da demanda",
            anticipate_planning: "Antecipar próximos planejamentos",
            replanning_amount: "Quantidade de replanejamento",
            date: "Data",
            must_be_bigger_equal_than_start_date: "Precisa ser maior ou igual a data inicial",
            must_be_less_equal_than_final_date: "Precisa ser menor ou igual a data final",
            must_be_bigger_than_start_date: "Precisa ser maior que a data inicial",
            must_be_less_than_final_date: "Precisa ser menor que a data final",
            must_be_bigger_than_start_time: "Precisa ser maior que a hora inicial",
            must_be_less_than_final_time: "Precisa ser menor que a hora final",
            line_setup: "Setup de linha",
            no_records_found: "Nenhum registro encontrado",
            demand_used_hours: "Horas usadas por demanda",
            group_by: "Agrupado por",
            consolidated: "Consolidado",
            detailed: "Detalhado",
            import_material_transit: "Importar materiais em trânsito",
            product_description: "Descrição do produto",
            delivery_date: "Data de entrega",
            result: "Resultado",
            side_a: "Lado A",
            side_b: "Lado B",
            max_qtd: "Quantidade máx. ",
            product_model: "Modelo do produto",
            title_event: "evento",
            attention: "Atenção",
            exists_planning: "Já existe planejamento neste período, deseja continuar e replanejar?",
            add_delay: "Preencha para retardar o inicio da linha de produção do backend.",
            delivery: "Entrega",
            planning_by_delivery: "Planejamento por entrega",
            no_planned: "Não planejado",
            input: "Insumo",
            create_demand: "Criar demanda",
            simulation_options: "Opções da simulação",
            max_value: "O campo não pode ser maior que ",
            min_value: "O campo não pode ser menor que ",
            invalid_quantity: "Quantidade insulficiente para criar demanda",
            value: "Valor",
            MAIL_HOST: "E-mail host",
            MAIL_PORT: "E-mail porta",
            MAIL_SENDER: "Remetente de email",
            MAIL_PASSWORD: "Senha do e-mail",
            MAIL_USE_TLS: "Uso de TLS no e-mail",
            MAIL_USE_SSL: "Uso de SSL no e-mail",
            DEMAND_DAYS_BEFORE_VALIDATE: "Dias antes de validar demandas",
            EMAILS_TO_ALERT: "E-mails para alertar",
            PRODUCTION_PLAN_XLS_PATH: "Local para gerar o arquivo xls do planejamento",
            notifications: "Notificações",
            verify_demand: "Verificar demanda",
            production_line_manual: "Linha de produção manual",
            production_line_smt: "Linha de produção SMT",
            next: "Próximo",
            previous: "Anterior",
            select_demand: "Selecionar demanda",
            adjust_variables: "Ajustar variáveis",
            define_period_and_shifts: "Definir turnos e período",
            top_bottom_different_line: "Top / Bottom em linhas diferentes",
            planned_qty: "Qtd. planejada",
            head_count: "Head count",
            production_time: "Tempo de produção",
            ramp: "Rampa",
            input_a_value: "Digite o valor",
            greater_than_equal_0: "O campo deve ser maior ou igual a 0",
            greater_than_equal_1: "O campo deve ser maior ou igual a 1",
            less_than_equal_1000: "O campo deve ser menor que 1000",
            generate_demand: "Gerar demandas",
            line_setting: "Configuração de linha",
            smt: "SMT",
            manual: "Manual",
            aligned: "Alinhado",
            create: "Criar",
            delete_simulation: "Limpar planejamentos futuros",
            simulation_result: "Resultado da simulação",
            sync: "Sincronizar",
            delayed: "Atrasado",
            total_simulations: "Total de simulações",
            plannings_removed: "Planejamentos removidos",
            optimization_progress: "Progresso da otimização",
            optimization_started: "Otimização iniciada",
            optimization_finalized: "Otimização finalizada",
            downtime_reason: "Motivo de parada",
            downtime: "Parada",
            scheduled: "Programada",
            unscheduled: "Não programada",
            downtime_ranking: "Ranking de paradas",
            reason_qty: "Quantidade",
            downtime_summary_by_quantity_report: "Paradas por tempo e quantidade",
            downtime_summary_by_available_time_report: "Paradas por tempo disponível",
            downtime_by_year: "Paradas por ano",
            downtime_by_month: "Paradas por mês",
            downtime_by_week: "Paradas por semana",
            downtime_by_day: "Paradas por dia",
            report_by_available_time: "Relatório por tempo disponível",
            time: "Tempo",
            report_type: "Tipo de relatório",
            planned_quantity_required: "Quantidade planejada é obrigatória",
            capacity_required: "Capacidade é obrigatória",
            import_production: "Importar produção",
            verify_planning: "Verificar planejamento",
            produced_quantity: "Quantidade produzida",
            week: "Semana",
            qty: "Quantidade",
            product_name: "Produto",
            segment_name: "Segmento",
            realized_and_planned_by_year: "Realizado vs planejado por ano",
            realized_and_planned_by_month: "Realizado vs planejado por mês",
            realized_and_planned_by_week: "Realizado vs planejado por semana",
            realized_and_planned_by_day: "Realizado vs planejado por dia",
            production_import_successful: "Produção importada com sucesso!",
            nothing_to_import: "Nada para importar",
            start_week: "Semana inicial",
            end_week: "Semana final",
            must_be_bigger_equal_than_start_week: "Precisa se maior que a semana inicial",
            select_by: "Selecionar por",
            oee_month_goal: "Meta mensal OEE",
            oee_year_goal: "Meta anual OEE",
            goal: "Meta",
            oee: "OEE",
            monthly: "Mensal",
            weekly: "Semanal",
            oee_one: "O.E.E.1",
            monthly_oee: "Mensal OEE1",
            year_oee: "Anual OEE1",
            month_target: "Meta mensal",
            year_target: "Meta anual",
            dashboard: "Dashboard",
            dashboard_oee: "Dashboard OEE",
            period: "Período",
            achieved: "Realizado",
            percentage: "Porcentagem",
            backlog: "Diferença",
            current_year_realized: "Realizado ano atual",
            current_year_backlog: "Diferença ano atual",
            current_month_realized: "Realizado mês atual",
            current_week_realized: "Realizado semana atual",
            ft_test_buffer: "FTTest Buffer",
            wip_volume: "Wip Volume",
            import_line_schedule: "Importar programação linha",
            serial_number: "Serial number",
            rev: "REV",
            bios_rev: "BIOS REV",
            model_name: "Modelo",
            group_name: "Grupo",
            next_station: "Próximo posto",
            last_log: "Data registro",
            working_time: "Tempo de trabalho",
            emp_no: "EMP NO",
            rota: "ROTA",
            total: "Total",
            line_schedule: "Programação de linha",
            hour: "Hora",
            today: "Hoje",
            production_order_demand: "Ordens de produção da demanda",
            buffer_chart: "Buffer Chart",
            delivery_file: "Arquivo de entrega",
            columns: "Columns",
            released_forecast: "Released forecast",
            total_backlog: "Total Backlog",
            slc_on_hand: "SLC On-Hand (LT=0)",
            factory_on_hand: "Factory On-Hand",
            projected_inventory: "Projected Inventory",
            projected_dsi: "Projected DSI",
            local_balance: "Inventário Local",
            update_with_planned: "Atualizar com o planejado",
            active_line_count: "Linhas ativas",
            active_line_shift: "Linhas ativas por turno",
            safety_stock_ok: "Estoque de segurança ok",
            excess_stock: "Estoque em excesso",
            stock_on_alert: "Estoque em alerta",
            critical_stock: "Estoque crítico",
            active_people_count: "Pessoas ativas",
            active_people_line: "Pessoas ativas por linha",
            upph: "UPPH",
            uph: "UPH",
            upph_production_line: "UPPH Linha de produção",
            send_final_version_planning: "Enviar versão final",
            successfully_send_planning: "Planejamento enviado com sucesso",
            final_version_planning: "Planejamento versão final",
            select_an_item_below: "Selecione um item ao lado",
            more_options: "Mais opções",
            invalid_emails: "Insira e-mails válidos separados por ponto e vírgula.",
            last_updated: "Última atualização",
            next_updated: "Próxima atualização",
            automatic: "Automático",
            manual_or_smt: "Manual ou SMT",
            urgent_planning: "Planejamento urgente",
            initial_quantity: "Quantidade inicial",
            yearly_chart: "Gráfico anual",
            monthly_chart: "Gráfico mensal",
            weekly_chart: "Gráfico semanal",
            daily_chart: "Gráfico diário",
            info_search_reports: "Os valores exibidos correspondem ao período selecionado",
            category: "Categoria",
            categories: "Categorias",
            category_name: "Nome da categoria",
            edit_category: "Editar categoria",
            new_category: "Nova categoria",
            projects: "Projetos",
            project_name: "Nome do projeto",
            new_project: "Novo projeto",
            client: "Cliente",
            part_numbers_register: "Cadastro de Part Numbers",
            project_platform: "Projeto/Platform",
            search_po_monitoring: "Pesquisar por Nº PO, Nº PR, categoria ou projeto",
            completed: "Entrega concluída",
            pending: "Entrega parcial",
            canceled: "Cancelada",
            po_number: "N° PO",
            origin: "Origem",
            po_monitoring: "Monitoramento PO",
            imported: "Importado",
            purchase_date: "Data criação",
            all: "Todos",
            search_project: "Pesquisar projeto por nome",
            edit_project: "Editar projeto",
            select_client: "Selecione o cliente",
            add_project: "Adicionar projeto",
            selected_projects: "Projetos selecionados",
            no_projects_selected: "Nenhum projeto selecionado",
            po_details: "Detalhamento da PO",
            pr_number: "N° PR",
            project: "Projeto",
            po_total: "Total PO",
            add_category: "Classificar PO",
            select_category_po: "Selecione a categoria da PO:",
            select_category: "Selecione uma categoria:",
            classify: "Classificar",
            po_added: "POs adicionadas",
            po_delivered: "POs entregues",
            po_in_partial_delivery: "POs em entrega parcial",
            added: "Adicionada",
            detail: "Detalhe",
            purchase_orders: "POs",
            import_purchase_orders: "Importação de POs",
            import_date: "Data de importação",
            import_status: "Status da importação",
            import_pos: "Importar PO(s)",
            processing: "Processando",
            fail_to_process: "Falha ao processar",
            processed: "Processado",
            amortization: "Amortização",
            import_amortization: "Importação de Amortização",
            latest_importation: "Última importação",
            import_nre_costs: "Importar NRE Costs",
            download: "Download",
            amortizations: "Amortização",
            asset_control: "Controle de Ativos",
            report_asset_control: "Relatório de Controle de Ativos",
            commodatum_agreements: "Contratos Comodatos",
            export: "Exportar",
            see_nfs: "Ver NFs",
            invoices: "Notas Fiscais",
            import_related_costs: "Importação de Custos Relacionados",
            import_related_costs_btn: "Importar Related Costs",
            related_costs: "Custos Relacionados",
            report_related_costs: "Relatório de Custos Relacionados",
            select_lob: "Selecione o LOB",
            successfully_import: "Arquivo adicionado com sucesso.",
            add_invoice_btn: "Cadastrar NF",
            add_invoice: "Cadastrar Nota Fiscal",
            select_project: "Selecione o projeto",
            invoice_code: "Código NF",
            partnumber_desc: "PartNumber/Description",
            partnumber_desc_info: "Informe partnumber e descrição da nota fiscal",
            invoice_value: "Valor NF",
            imports: "Importação",
            projects_for_amortization: "Projetos para Amortização",
            equal_value_for_all_projects: "Valor igual para todos os projetos",
            amortization_value: "Valor de Amortização",
            nre_cost_exists: "Já existe uma nota fiscal com esse número para esse projeto e categoria.",
            sum_of_values_greater_than_invoice_value: "A soma dos valores não pode ser maior que o valor da nota fiscal.",
            project_exists: "Já existe um projeto cadastrado com esse nome.",
            search_category: "Pesquisar por nome ou descrição",
            cost_allocation_by_project_category: "Rateio de Custos",
            report_cost_allocation_by_project_category: "Relatório de Rateio de Custos por Projeto e Categoria",
            nu_po: "Nº PO",
            created_date: "Data de criação",
            total_po: "Total PO",
            value_by_project: "Valor por projeto",
            search_po_by_code: "Pesquisar PO por código",
            list_material_po: "Listagem de materiais da PO",
            plan: "Planta",
            search_material: "Pesquisar material",
            stock_and_material_output: "Estoque e Saída de Materiais",
            report_stock_and_materia_output: "Relatório de Estoque e Saída de Materiais",
            who_removed: "Quem retirou",
            remove_date: "Data de retirada",
            qty_avaible: "Qtde disponível",
            last_update: "Última atualização",
            year_month: "Ano/Mês",
            report_ftb_general: "Relatório de FTB Geral",
            ftb_general: "FTB Geral",
            search_material_by_code_partnumber_description: "Pesquisar por part number, descrição ou Alt Grp Grl",
            total_produced: "Total produzido",
            quantity_of_jiga: "Quantidade de JIGA",
            add_partnumber: "Adicionar PartNumber",
            registered_partnumber: "PartNumber cadastrado",
            no_registered_partnumber: "Nenhum PartNumber cadastrado",
            ft_bom_groups: "Grupos de Materiais",
            new_ft_bom_group: "Novo grupo",
            edit_ft_bom_group: "Alterar grupo",
            search_ft_bom_group: "Pesquisar por código do grupo, descrição ou material",
            description_en: "Descrição EN",
            description_pt: "Descrição PT",
            associate_materials: "Vincular Materiais",
            associate_btn: "Vincular",
            search_ft_bom: "Pesquisar material por código, part number ou descrição",
            group_exists: "Já existe um grupo cadastrado com esse código.",
            total_nre: "Total NRE",
            total_amortized: "Total Amortized",
            open_nre: "Open NRE",
            qty_po_partial: "PO em Entrega Parcial",
            qty_po_added: "PO Pendente de Classificação",
            mount_jiga_rma: "Montar JIGA/RMA",
            quantity_of_rma: "Quantidade de RMA",
            category_cost_by_year: "Custo de Categoria por Ano",
            po_uncategorized_filter: "Pendente de Classificação",
            save_mount: "Salvar montagem",
            reuse_ftb_material: "Reutilizar materiais",
            reuse: "Reutilizar",
            pending_groups: "Grupos pendentes",
            reused_ftb_material: "Material reutilizado das FTBs",
            edit_reused_ftb_material: "Editar material reutilizado das FTB",
            replenishment: "Replenishment",
            last_replenishment: "Último Replenishment",
            clients: "Clientes",
            sapCode: "Código SAP",
            new_client: "Novo cliente",
            search_client: "Pesquisar por nome ou código SAP",
            edit_client: "Editar cliente",
            client_association_with_po: "Não é possível deletar clientes com POs associadas.",
            client_association_with_project: "Não é possível deletar clientes com projetos associados.",
            client_association_with_ftbom: "Não é possível deletar clientes com FTBOMs associadas.",
            add_client: "Adicionar cliente",
            select_client_po: "Selecione o cliente da PO:",
            select_client_ftb: "Selecione o cliente da FTB:",
            users: "Usuários",
            new_user: "Novo usuário",
            user_type: "Tipo de usuário",
            complete_name: "Nome completo",
            no_replenishment_info: "Sem previsões de replenishment",
            pending_nre_invoices: "Notas pendentes NRE",
            integration_routines: "Rotinas de integração (RFC - SAP)",
            confirmation_monitoring_po: "Confirmação de PO's para Monitoramento NRE",
            confirm_sending_po: "Confirmar o envio de POs",
            confirm_sending: "Confirmar envio",
            report: "Relatório",
            send_po: "Enviar PO",
            permission_denied_title: "Acesso não permitido",
            permission_denied_message: "Seu perfil não tem permissão para acessar esta área. Solicite acesso ao administrador, se necessário.",
            configuration: "Configuração",
            template: "Template",
            new_npi: "Novo NPI",
            export_label: "Exportar",
            export_image_png: "Imagem (PNG)",
            export_image_error: "Não foi possível gerar a imagem do dashboard.",
            generated_at: "Gerado em",
            planning_template: "Templates de Planejamento",
            board: "Placa",
            monitor: "Monitor",
            activity: "Atividade",
            resource: "Recurso",
            baseline_start: "Início baseline",
            baseline_end: "Fim baseline",
            exec_start: "Início execução",
            exec_end: "Fim execução",
            atrasado_ha: "Atrasado há",
            dias: "dias",
            nao_iniciada_label: "Não iniciada",
            concluido_label: "Concluído",
            em_andamento_label: "Em andamento",
            atrasado_label: "Atrasado",
            id: "ID",
            project_planning: "Planejamento do projeto",
            npi_project: "Projeto NPI",
            progress: "Progresso",
            total_projects: "Total de projetos",
            completed_steps: "Etapas concluídas",
            in_progress_summary: "Atividades em andamento",
            pending_not_started: "Atividades pendentes (não iniciadas)",
            search_step_or_project: "Buscar projeto, fase ou etapa...",
            npi_dashboard_empty_title: "Nenhum projeto para exibir",
            npi_dashboard_empty_description: "Não há projetos NPI para os filtros selecionados. Ajuste o cliente, ano ou tipo de projeto.",
            npi_dashboard_no_results_title: "Nenhum resultado encontrado",
            npi_dashboard_no_results_description: "Nenhum projeto, fase ou etapa corresponde à busca \"{{term}}\".",
            delayed_for_3_days: "Em atraso há 3 dias",
            dashboard_step: "Etapa",
            status_delayed_legend: "Em atraso",
            status_running_legend: "Em execução",
            activities: "Atividades",
            frc: "FRC",
            execution_start: "Início Execução",
            execution_end: "Fim Execução",
            status_completed: "Concluído",
            status_completed_late: "Concluído com atraso",
            status_in_progress: "Em andamento",
            status_delayed: "Atrasado",
            status_not_started: "Não iniciada",
            status_not_executed: "Não será executada",
            complete_activity: "Concluir atividade",
            duration_change_warning: "Alterar a duração impactará o restante do cronograma.",
            duration_must_be_positive: "A duração deve ser maior que zero.",
            mark_not_executed: "Marcar como não será executada",
            undo_not_executed: "Desfazer não será executada",
            delayed_days_ago_one: "Atrasado há {{count}} dia",
            delayed_days_ago_other: "Atrasado há {{count}} dias",
            completed_late_days_one: "Concluído com {{count}} dia de atraso",
            completed_late_days_other: "Concluído com {{count}} dias de atraso",
            new_activity: "Nova Atividade",
            new_template: "Novo Template",
            edit_template: "Editar Template",
            search_template: "Pesquisar por nome do template",
            template_name: "Nome do template",
            project_type: "Tipo de projeto",
            new_project_type: "Novo tipo de projeto",
            edit_project_type: "Editar tipo de projeto",
            create_new: "Criar novo",
            project_type_in_use: "Este tipo de projeto está em uso e não pode ser excluído",
            copy_template: "Copiar template",
            none: "Nenhum",
            back: "Voltar",
            select: "Selecione",
            copy: "Cópia",
            new_group: "Novo grupo",
            total_deadline: "Prazo total",
            phases: "Fases",
            task_name: "Task name",
            task_status: "Status",
            task_acronym: "Task (sigla)",
            deadline: "Prazo",
            predecessor: "Predecessor",
            no_predecessor: "Sem predecessor",
            search_task: "Buscar tarefa...",
            template_detail: "Detalhamento do Template",
            no_groups: "Nenhum grupo adicionado ao template",
            name_of_group: "Nome do grupo",
            new_subgroup: "Novo subgrupo",
            save_to_set_predecessor: "Salve a atividade para definir um predecessor",
            group_already_added: "Já existe um grupo com este nome.",
            task_acronym_already_added: "Já existe uma atividade com esta sigla.",
            confirm_delete_group: "Você tem certeza que deseja excluir este grupo?",
            confirm_delete_activity: "Você tem certeza que deseja excluir esta atividade?",
            template_already_added: "Já existe um template de NPI com este nome.",
            project_type_already_added: "Já existe um tipo de projeto com este nome.",
            calendars: "Calendários",
            select_calendar: "Selecionar calendário",
            side_by_side: "Lado a lado",
            view_mode: "Modo de visualização",
            legend: "Legenda",
            national_holiday: "Feriado Nacional",
            manaus_holiday: "Feriado MANAUS",
            sao_paulo_holiday: "Feriado São Paulo",
            holiday: "Feriado",
            tiaoxiu_legend: "Tiaoxiu (Sáb/Dom de Trabalho na CHINA)",
            weekend: "Fim de Semana",
            normal_business_day: "Dia Útil Normal",
            annual_calendar: "Calendário Anual",
            add_holiday: "Adicionar feriado",
            brasil: "Brasil",
            china: "CHINA",
            holidays_and_events_of_month: "Feriados & Eventos do Mês",
            no_holidays_this_month: "Nenhum feriado neste mês",
            confirm_delete_holiday: "Tem certeza que deseja excluir este feriado?",
            holidays_and_events_of_year: "Feriados & Eventos do Ano",
            expand_group: "Expandir grupo",
            collapse_group: "Recolher grupo",
            template_linked_to_npi: "Não é permitido excluir um template vinculado a um NPI.",
            feriado: "Feriado",
            tiaoxiu: "Tiaoxiu",
            confirm_status_change: "Tem certeza que deseja concluir esta atividade?",
            confirm_mark_not_executed: "Tem certeza que deseja marcar esta atividade como <bold>não será executada</bold>?",
            confirm_undo_not_executed: "Tem certeza que deseja desfazer a marcação desta atividade como <bold>não será executada</bold>?",
            confirm_delete_npi: "Tem certeza que deseja excluir este template de NPI?",
            confirm_delete_header: "Apagar item NPI",
            npi_checklist: "NPI Checklist",
            npi_product_checklist: "NPI Product Checklist",
            new_npi_checklist: "Novo Checklist de Produto (NPI)",
            product_project_name: "Nome do Produto / Projeto",
            insert_part_number: "Insira o número do part number",
            part_number_read_only: "Para alterar, remova o part number pela lixeira e adicione novamente",
            part_number_already_added: "Este part number já foi adicionado.",
            checklist_template: "Template do Checklist",
            click_to_add_file: "Clique aqui para adicionar o arquivo.",
            excel_max_size: "XLS ou XLSX (máx. 5MB)",
            remove_file: "Remover arquivo",
            file_exceeds_max_size: "O arquivo deve ter no máximo 5MB.",
            checklist_schedule: "Cronograma",
            checklist_filters: "Filtros",
            checklist_all_status: "Todos Status",
            checklist_responsible: "Responsável",
            checklist_responsibles: "Responsáveis",
            checklist_clear_filters: "Limpar filtros",
            checklist_send_report: "Enviar report",
            checklist_item: "Item",
            checklist_requirement_description: "Descrição do requisito",
            checklist_final_deadline: "Prazo final",
            checklist_completion_date: "Data conclusão",
            checklist_no_items_found: "Nenhum item encontrado para os filtros selecionados.",
            checklist_validate: "Validar",
            checklist_comment: "Comentar",
            npi_transfer_phases: "Cronograma de fases NPI (transfer phases)",
            npi_transfer_progress: "Progresso da transferência NPI",
            checklist_completed_label: "Completo",
            phase_completed: "Concluída",
            phase_in_progress: "Em Execução",
            phase_pending: "Pendente / Em Risco",
            checklist_status_overview: "Status geral do checklist & demandas NPI",
            mapped_requirements: "requisitos mapeados",
            checklist_complete: "Concluído",
            checklist_on_going: "Em andamento",
            checklist_at_risk: "Em risco / Pendente",
            checklist_not_applicable: "N/A",
            checklist_legend_green: "Verde",
            checklist_legend_yellow: "Amarelo",
            checklist_legend_red: "Vermelho",
            oem_client: "OEM / Cliente",
            odm_manufacturer: "ODM / Fabricante",
            part_numbers: "Part numbers",
            pcba_rev: "PCBA REV",
            kickoff: "Kickoff",
            checklist_empty_title: "Nenhum checklist para exibir",
            no_checklist_found: "Nenhum checklist encontrado para o cliente e ano selecionados.",
        }
    }
};

export {messages};
